import cn from 'classnames';

import {largeModelEcosystemService as data, moduleTitleCn, moduleContentCn} from '~/locals/aigallery/index';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';

import {ArrowBtn} from './components';

import styles from '~/style/aigallery/largeModelEcosystemService.module.less';

const id = 'largeModelEcosystemService';
const LargeModelEcosystemService = () => {
    useCptDuration(id, {
        name: `${applicationName}-更多大模型生态服务-停留时长`,
    });
    return (
        <div className={styles.container} id={id}>
            <div className={cn(styles.title, `${moduleTitleCn}`)}>{data.title}</div>
            <div className={cn(styles.main, `${moduleContentCn}`)}>
                {data.cardItems.map(item => {
                    return (
                        <div
                            key={item.id}
                            className={styles.card}
                            onClick={() => {
                                if (typeof window !== 'undefined') {
                                    window?.open?.(item.href, '_blank');
                                }
                            }}
                        >
                            <div class={styles['card-title']}>{item.title}</div>
                            <div className={styles['card-desc']}>{item.desc}</div>
                            <ArrowBtn
                                data={{
                                    link: item.href,
                                    text: item.hrefText,
                                    third: true,
                                    trackInfo: item.trackInfo,
                                }}
                                className={styles.arrowBtn}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default LargeModelEcosystemService;
